<template>
  <div class="bq_content">
    <!--<div class="banner"><div class="wrap"><img src="~@/assets/images/bquery/banner.png" alt=""></div></div>-->
    <div class="banner">
      <div class="wrap">
        <div class="banner_content">
          <div class="banner_content_title">企业FTA诊断功能上线啦!</div>
          <div class="subtitle">一键查询  节税不愁</div>
          <div class="banner_desc">为协助企业合法合规节省关税，进一步优化进出口产品种类繁多的企业进行FTA节税筹划的效率，O-TECH正式推出企业FTA诊断功能，提供“批量导入，实时查询，一键下载”的便捷查询服务，让进出口节税不再费时费力。</div>
          <div class="btns">
            <div class="btn" v-if="dataSet && (!dataSet.id || dataSet.status === 1)" @click="onApply">申请企业FTA诊断</div>
            <!-- <Button class="btn doing" loading v-else-if="dataSet && dataSet.status === 0">申请已提交，请等待</Button> -->
            <div class="doing_wrap" v-else-if="dataSet && dataSet.status === 0">
              <Button class="btn waiting" icon="ios-checkmark-outline">申请已提交，请等待</Button>
              <div class="waiting_desc">
                <span>已收到您的申请，我们将在三天内答复，如需加急，请在公众号留言：</span>
                <div>
                  <img src="~@/assets/images/bquery/min_qrcode.png" class="mincode" alt="" @mouseover="isShowQR=true" @mouseout="isShowQR=false">
                  <img src="~@/assets/images/bquery/qrcode.png" class="qrcode" alt="" v-show="isShowQR">
                </div>
                <span style="white-space: nowrap;">O-TECH</span>
              </div>
            </div>
            <a v-if="dataSet && (!dataSet.id && !dataSet.result)" href="https://hifun-test.oss-cn-shanghai.aliyuncs.com/otech/%E6%89%B9%E9%87%8F%E6%9F%A5%E8%AF%A2%E6%95%B0%E6%8D%AE%E6%A8%A1%E6%9D%BF.xlsx" traget="_blank" class="btn download">下载查询模板</a>
            <a class="btn done" v-if="dataSet && dataSet.status === 1 && dataSet.result" :href="dataSet.result" target="_blank">下载报告</a>
          </div>
        </div>
        <img src="~@/assets/images/bquery/person.png" alt="">
      </div>
    </div>
    <div class="bg_main">
      <div class="item fun_item">
        <div class="title">
          功能说明<span class="subtitle">Function Description</span>
          <span class="dw">
            <a href="https://hifun-test.oss-cn-shanghai.aliyuncs.com/otech/%E6%89%B9%E9%87%8F%E6%9F%A5%E8%AF%A2%E6%95%B0%E6%8D%AE%E6%A8%A1%E6%9D%BF.xlsx" target="_blank">企业FTA诊断上传模板</a>
          </span>
        </div>
        <div class="desc">为企业或个人用户提供进出口商品的税率信息、关税筹划建议及相关经贸快讯的企业FTA诊断功能</div>
        <div class="fee">每20个税号查询扣除1000积点，不足1000积点以1000积点扣除。</div>
      </div>
      <div class="item flow_item">
        <div class="title">
          流程说明<span class="subtitle">Flow description</span>
        </div>
        <!--<img src="~@/assets/images/bquery/image.png" alt="">-->
        <div class="flow_content">
          <div class="flow_content_wrap">
            <img src="~@/assets/images/bquery/cloud.gif" alt="">
            <a href="https://hifun-test.oss-cn-shanghai.aliyuncs.com/otech/%E6%89%B9%E9%87%8F%E6%9F%A5%E8%AF%A2%E6%95%B0%E6%8D%AE%E6%A8%A1%E6%9D%BF.xlsx" traget="_blank">模板下载</a>
          </div>
        </div>
      </div>
      <div class="item step_item">
        <div class="title">详细步骤<span class="subtitle">Detailed Steps</span></div>
        <div class="steps">
          <img src="~@/assets/images/bquery/step.png" alt="">
          <!--<Row>-->
            <!--<Col span="4" class="si_item">-->
              <!--<div class="si_content"><div class="si_item_wrap"><div class="sn">01</div><div class="name">登录查询</div></div></div>-->
              <!--<div class="si_desc"><div>登录O-TECH网站</div><div>(www.otechsolution.com)</div><div>点击“批量查询”</div></div>-->
            <!--</Col>-->
            <!--<Col span="1" class="si_img"><img src="~@/assets/images/bquery/icon_next.png" alt=""></Col>-->
            <!--<Col span="4" class="si_item">-->
              <!--<div class="si_content"><div class="si_item_wrap"><div class="sn">02</div><div class="name">填写信息</div></div></div>-->
              <!--<div class="si_desc"><div>填写申请人以及</div><div>联系信息</div></div>-->
            <!--</Col>-->
            <!--<Col span="1" class="si_img"><img src="~@/assets/images/bquery/icon_next.png" alt=""></Col>-->
            <!--<Col span="4" class="si_item">-->
              <!--<div class="si_content"><div class="si_item_wrap"><div class="sn">03</div><div class="name">下载模板</div></div></div>-->
              <!--<div class="si_desc"><div>选择下载“批量查询模板表”</div><div>批量查询模板表的列项不能改动</div><div>只需逐行填写必填项的信息即可</div></div>-->
            <!--</Col>-->
            <!--<Col span="1" class="si_img"><img src="~@/assets/images/bquery/icon_next.png" alt=""></Col>-->
            <!--<Col span="4" class="si_item">-->
              <!--<div class="si_content"><div class="si_item_wrap"><div class="sn">04</div><div class="name">上传信息</div></div></div>-->
              <!--<div class="si_desc"><div>上传填写完毕的批量</div><div>查询模板表</div></div>-->
            <!--</Col>-->
            <!--<Col span="1" class="si_img"><img src="~@/assets/images/bquery/icon_next.png" alt=""></Col>-->
            <!--<Col span="4" class="si_item">-->
              <!--<div class="si_content"><div class="si_item_wrap"><div class="sn">05</div><div class="name">下载报告</div></div></div>-->
              <!--<div class="si_desc"><div>等待数据处理完毕后</div><div>即可在线下载批量查询报告</div></div>-->
            <!--</Col>-->
          <!--</Row>-->
        </div>
      </div>
      <!-- <div class="btn" v-if="dataSet && !dataSet.id" @click="onApply">申请批量查询</div>
      <Button class="btn doing" loading v-if="dataSet && dataSet.id && dataSet.status === 0">申请已提交，请等待</Button>
      <a class="btn done" v-if="dataSet && dataSet.id && dataSet.status === 1 && dataSet.result" :href="dataSet.result" target="_blank">点击下载报告</a> -->
    </div>
    <Loader :loadType="1" v-show="isShowLoader" style="position: fixed;top:80px;" class="black"></Loader>
    <Modal :isShow="isShowModal" :dataSet="dataSet" @changeState="isShowModal=$event"></Modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import Loader from '@/components/layout/Loader'
import Modal from './Modal'
const { mapState: mapDataState, mapGetters: mapDataGetters } = createNamespacedHelpers('data')

export default {
  name: 'BatchQueryContent',
  components: { Loader, Modal },
  data () {
    return {
      isShowQR: false,
      isShowLoader: false,
      isShowModal: false,
      dataSet: null
    }
  },
  computed: {
    apiPrice () {
      if (this._.isEmpty(this.apiValue)) {
        return null
      } else {
        return this.getApiValue()
      }
    },
    ...mapDataState({
      apiValue: state => state.apiValue
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.getData()
    })
  },
  methods: {
    getData () {
      if (this.isShowLoader) return
      this.$Loading.start()
      this.isShowLoader = true
      this.$api.batchQuery.get({
        success: response => {
          this.$Loading.finish()
          if (response.data.code === 200) {
            this.dataSet = response.data.data
          } else {
            this.$Message.warning({content: this.$t('common.codeError'), closable: true})
          }
          this.isShowLoader = false
        },
        error: errorMsg => {
          this.isShowLoader = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    },
    onApply () {
      // if (this.dataSet && this.dataSet.mobile && this.dataSet.email) {
      if (this.dataSet) {
        this.GConfirm(`本次查询将消耗1000积点。`, status => {
          if (status) {
            this.isShowModal = true
          }
        })
      } else {
        this.$Message.info('个人用户尚未开放此功能')
      }
    },
    ApplyOk () {
      this.dataSet.id = -1
      this.dataSet.status = 0
    },
    ...mapDataGetters([
      'getApiValue'
    ])
  }
}
</script>
<style scoped>
  .banner{
    background-color: #F1F8FF;
  }
  .banner .wrap{
    max-width: 1360px;
    /*width: 100%;*/
    margin: 0 auto;
    width: 64%;
    position: relative;
    min-height: 300px;
    padding: 55px 380px 55px 0;
    display: flex;
    align-items: center;
  }
  .banner img{
    /*width: 100%;*/
    position: absolute;
    height: 230px;
    right: 0;
    top: 35px;
  }
  .banner .banner_content_title{
    font-size: 24px;
    color: #1F8AFD;
  }
  .banner .subtitle{
    font-size: 17px;
    color: #333;
    margin: 10px 0 13px;
    font-weight: bold;
  }
  .banner .banner_desc{
    color: #666;
    line-height: 26px;
    font-size: 16px;
    letter-spacing: 0.5px;
  }
  .banner a{
    color: #1F8AFD;
  }
  .bg_main{
    width: 64%;
    margin: 0 auto;
    /*max-width: 960px;*/
    max-width: 1360px;
  }
  .bg_main .item:first-child{
    margin-top: 36px;
  }
  .bg_main .item{
    margin-top: 42px;
  }
  .bg_main .item .title{
    background: url("~@/assets/images/bquery/icon.png") no-repeat 0 center transparent;
    background-size: 10px auto;
    padding-left: 18px;
    font-size: 16px;
    color: #333;
    margin-bottom: 10px;
  }
  .bg_main .item .title .subtitle{
    color: #CFCFCF;
    font-size: 12px;
    padding-left: 15px;
  }
  .bg_main .item .desc{
    color: #666;
    font-size: 15px;
  }
  .bg_main .item .fee{
    margin-top:10px;
    font-size: 15px;
    color: #ea2c2c;
  }
  .bg_main .flow_item .title,
  .bg_main .fun_item .title{
    position: relative;
  }
  .bg_main .flow_item .title .dw,
  .bg_main .fun_item .title .dw{
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .bg_main .fun_item .title .dw{
    right: -30px;
  }
  .bg_main .flow_item .title a,
  .bg_main .fun_item .title a{
    color: #17BB6D;
    font-size: 15px;
    background: url("~@/assets/images/bquery/xiazai.png") 0 center no-repeat transparent;
    background-size: 16px auto;
    padding-left: 18px;
    display: block;
  }
  .bg_main .flow_item .title a:first-child,
  .bg_main .fun_item .title a:first-child{
    /*margin-right: 20px;*/
    /*color: #1F8AFD;*/
  }
  .bg_main .flow_item .title a::after,
  .bg_main .fun_item .title a::after{
    background-color: #17BB6D;
  }
  /*.bg_main .flow_item .title a:first-child::after{*/
    /*background-color: #1F8AFD;*/
  /*}*/
  .bg_main .flow_item .flow_content{
    position: relative;
  }
  .bg_main .flow_item .flow_content_wrap{
    position: relative;
    width: 70%;
    margin: 35px auto 55px;
  }
  .bg_main .flow_item img{
    /* width: 70%;
    margin: 35px auto 55px; */
    width: 100%;
  }
  .bg_main .flow_item .flow_content a{
    position: absolute;
    /* left: 5.3%; */
    left: 0;
    top: 82%;
    width: 8.5%;
    display: block;
    /*font-weight: bold;*/
    color: #1F8AFD;
    font-size: 15px;
    text-align: center;
  }
  .step_item{
    margin-bottom: 80px;
  }
  .step_item .steps{
    margin-top: 42px;
  }
  /*.step_item .si_content{*/
    /*width: 70%;*/
    /*padding: 70% 0 0;*/
    /*border-radius: 100%;*/
    /*border: 1px dashed #A8D3FA;*/
    /*position: relative;*/
    /*!*overflow: hidden;*!*/
  /*}*/
  /*.step_item .si_content:after{*/
    /*content: " ";*/
    /*background: url("~@/assets/images/bquery/icon_next.png") no-repeat 0 0 transparent;*/
    /*background-size: 35px auto;*/
    /*width: 35px;*/
    /*height: 19px;*/
    /*position: absolute;*/
    /*top: 50%;*/
    /*right: -45%;*/
    /*transform: translateY(-50%);*/
  /*}*/
  /*.step_item .si_item:last-of-type .si_content:after{*/
    /*content: "";*/
    /*display: none;*/
  /*}*/
  /*.step_item .si_content .si_item_wrap{*/
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    /*flex-direction: column;*/
    /*position: absolute;*/
    /*top: 0;*/
    /*left: 0;*/
    /*height: 100%;*/
    /*width: 100%;*/
    /*font-size: 14px;*/
    /*color: #1F8AFD;*/
  /*}*/
  /*.step_item .si_content .si_item_wrap .name{*/
    /*font-size: 13px;*/
    /*margin-top: 2px;*/
  /*}*/
  /*.step_item .si_desc{*/
    /*!*width: 80%;*!*/
    /*font-size: 12px;*/
    /*!*text-align: center;*!*/
    /*color: #666;*/
    /*margin-top: 15px;*/
  /*}*/
  /*.step_item .si_desc div{*/
    /*margin-top: 5px;*/
  /*}*/
  /*.step_item .si_img{*/
    /*visibility: hidden;*/
  /*}*/
  .btns{
    display: flex;
    margin-top: 25px;
  }
  .btn{
    background-image: linear-gradient(90deg, #42BEFF 9%, #1F8AFD 100%);
    border-radius: 3px;
    width: 140px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    font-size: 13px;
    color: #fff;
    cursor: pointer;
    /* margin: 0 auto 60px; */
  }
  .btn.doing,
  .btn.waiting,
  .btn.download{
    background-image: none;
    border: 0.5px solid #1F8AFD;
    color: #1F8AFD;
    cursor: default;
    width: 160px;
    padding: 0;
    background-color: transparent;
    display: block;
  }
  .btn.waiting{
    background-image: linear-gradient(90deg, #42BEFF 9%, #1F8AFD 100%);
    color: #fff;
    width: 170px;
    border: 0 none;
    margin-bottom: 15px;
  }
  .btn.waiting >>> .ivu-icon{
    font-size: 16px;
    position: relative;
    top: 1px;
  }
  .waiting_desc{
    font-size: 14px;
    color: #ea2c2c;
    display: flex;
    align-items: center;
  }
  .waiting_desc div{
    position: relative;
    margin: 0 10px 0 6px;
  }
  .waiting_desc .mincode{
    position: static;
    width: 20px;
    height: 20px;
    display: block;
    cursor: pointer;
    max-width: inherit;
  }
  .waiting_desc .qrcode{
    position: absolute;
    top: 50%;
    left: 100%;
    transform: translateY(-50%);
    z-index: 1;
    width: 120px;
    height: 120px;
    right: inherit;
    max-width:inherit;
  }
  .btn.done{
    display: block;
    background-image: linear-gradient(90deg, #2EDC75 0%, #17BB6D 100%);
    color: #fff;
    margin-left: 20px;
  }
  .btn.done:after,
  .btn.download:after{
    content: "";
    display: none;
  }
  .btn.download{
    margin-left: 20px;
    width: 140px;
    cursor: pointer;
  }
  @media print,screen and (max-width:1365px) {
    .banner .banner_content_title{
      font-size: 20px;
    }
    .banner .subtitle{
      font-size: 16px;
    }
    .banner .banner_desc{
      font-size: 14px;
    }
    .bg_main .item .title{
      font-size: 15px;
    }
    .bg_main .item .desc{
      font-size: 14px;
    }
    .bg_main .item .fee{
      font-size: 14px;
    }
    .bg_main .flow_item .title a{
      /*font-size: 13px;*/
      font-size: 14px;
      background-size: 14px;
      padding-left: 16px;
    }
    .bg_main .flow_item .flow_content a{
      font-size: 12px;
      white-space: nowrap;
      top: 84%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/batchQuery/zh-CN/Content.vue